import { Component } from '@angular/core';
import {Observable} from "rxjs";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {map, shareReplay} from "rxjs/operators";
import {AuthService} from "./services/auth.service";
import {Router, RouterOutlet, RouterLink} from "@angular/router";
import {NgIf, AsyncPipe} from '@angular/common';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {NavigationComponent} from './navigation/navigation.component';
import {environment} from "../environments/environment";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        AsyncPipe,
        RouterOutlet,
        RouterLink,
        MatSidenavModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatDividerModule,
        ClipboardModule,
        NavigationComponent
    ]
})
export class AppComponent {
  title = 'Ball Score';
  public environmentAlias: string;
  public release: string;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  isFullscreen(): boolean {
    return this.router.url.startsWith("/broadcast-layer/") ||
      this.router.url.startsWith("/user-layer/") ||
      this.router.url.startsWith("/broadcast-control/");
  }

  getUserOutputUrl() {
    if (!this.auth.user) return '';
    const href = window.location.href;
    return href.substring(0, href.indexOf('/', 8)) + '/user-layer/' + this.auth.user.uid;
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    public auth: AuthService,
    private router: Router,
  ) {
    this.environmentAlias = environment.environmentAlias;
    this.release = environment.release;
  }
}
